"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionBracket = instanceOfCompetitionBracket;
exports.CompetitionBracketFromJSON = CompetitionBracketFromJSON;
exports.CompetitionBracketFromJSONTyped = CompetitionBracketFromJSONTyped;
exports.CompetitionBracketToJSON = CompetitionBracketToJSON;
exports.CompetitionBracketToJSONTyped = CompetitionBracketToJSONTyped;
var Competition_1 = require("./Competition");
var CompetitionBracketSettings_1 = require("./CompetitionBracketSettings");
var Ace_1 = require("./Ace");
var BracketMatch_1 = require("./BracketMatch");
var BracketAssignment_1 = require("./BracketAssignment");
var BracketState_1 = require("./BracketState");
var BracketProvider_1 = require("./BracketProvider");
var CompetitionFormFilter_1 = require("./CompetitionFormFilter");
var BracketRound_1 = require("./BracketRound");
var CompetitionBracketChannel_1 = require("./CompetitionBracketChannel");
/**
 * Check if a given object implements the CompetitionBracket interface.
 */
function instanceOfCompetitionBracket(value) {
    return true;
}
function CompetitionBracketFromJSON(json) {
    return CompetitionBracketFromJSONTyped(json, false);
}
function CompetitionBracketFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'competition': json['competition'] == null ? undefined : (0, Competition_1.CompetitionFromJSON)(json['competition']),
        'name': json['name'] == null ? undefined : json['name'],
        'externalProvider': json['externalProvider'] == null ? undefined : (0, BracketProvider_1.BracketProviderFromJSON)(json['externalProvider']),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'externalKey': json['externalKey'] == null ? undefined : json['externalKey'],
        'syncToMatchm': json['syncToMatchm'] == null ? undefined : json['syncToMatchm'],
        'state': json['state'] == null ? undefined : (0, BracketState_1.BracketStateFromJSON)(json['state']),
        'options': json['options'] == null ? undefined : json['options'],
        'disambiguatingDescription': json['disambiguatingDescription'] == null ? undefined : json['disambiguatingDescription'],
        'hasRounds': json['hasRounds'] == null ? undefined : json['hasRounds'],
        'canAssignIfNot': json['canAssignIfNot'] == null ? undefined : (0, BracketState_1.BracketStateFromJSON)(json['canAssignIfNot']),
        'channel': json['channel'] == null ? undefined : (0, CompetitionBracketChannel_1.CompetitionBracketChannelFromJSON)(json['channel']),
        'settings': json['settings'] == null ? undefined : (0, CompetitionBracketSettings_1.CompetitionBracketSettingsFromJSON)(json['settings']),
        'matches': json['matches'] == null ? undefined : (json['matches'].map(BracketMatch_1.BracketMatchFromJSON)),
        'assignments': json['assignments'] == null ? undefined : (json['assignments'].map(BracketAssignment_1.BracketAssignmentFromJSON)),
        'rounds': json['rounds'] == null ? undefined : (json['rounds'].map(BracketRound_1.BracketRoundFromJSON)),
        'formFilters': json['formFilters'] == null ? undefined : (json['formFilters'].map(CompetitionFormFilter_1.CompetitionFormFilterFromJSON)),
        'listed': json['listed'] == null ? undefined : json['listed'],
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function CompetitionBracketToJSON(json) {
    return CompetitionBracketToJSONTyped(json, false);
}
function CompetitionBracketToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': value['owner'],
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'acesInheriting': value['acesInheriting'],
        'competition': (0, Competition_1.CompetitionToJSON)(value['competition']),
        'name': value['name'],
        'externalProvider': (0, BracketProvider_1.BracketProviderToJSON)(value['externalProvider']),
        'externalId': value['externalId'],
        'externalKey': value['externalKey'],
        'syncToMatchm': value['syncToMatchm'],
        'state': (0, BracketState_1.BracketStateToJSON)(value['state']),
        'options': value['options'],
        'disambiguatingDescription': value['disambiguatingDescription'],
        'hasRounds': value['hasRounds'],
        'canAssignIfNot': (0, BracketState_1.BracketStateToJSON)(value['canAssignIfNot']),
        'channel': (0, CompetitionBracketChannel_1.CompetitionBracketChannelToJSON)(value['channel']),
        'settings': (0, CompetitionBracketSettings_1.CompetitionBracketSettingsToJSON)(value['settings']),
        'matches': value['matches'] == null ? undefined : (value['matches'].map(BracketMatch_1.BracketMatchToJSON)),
        'assignments': value['assignments'] == null ? undefined : (value['assignments'].map(BracketAssignment_1.BracketAssignmentToJSON)),
        'rounds': value['rounds'] == null ? undefined : (value['rounds'].map(BracketRound_1.BracketRoundToJSON)),
        'formFilters': value['formFilters'] == null ? undefined : (value['formFilters'].map(CompetitionFormFilter_1.CompetitionFormFilterToJSON)),
        'listed': value['listed'],
        'illegal': value['illegal'],
    };
}
